import { render, staticRenderFns } from "./DocumentiDetails.vue?vue&type=template&id=6792a7b0&"
import script from "./DocumentiDetails.vue?vue&type=script&lang=js&"
export * from "./DocumentiDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports